(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/login-register/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/login-register/constants.js');

const FORMS = {
  EMAIL: {
    EMAIL_LABEL: 'E-postadress',
    EMAIL_MAX: 100,
    EMAIL_REQUIRED_ERROR: 'Du måste ange en e-postadress',
    EMAIL_NAME: 'email'
  },
  PASSWORD: {
    PASSWORD_LABEL: 'Lösenord',
    PASSWORD_REQUIRED_ERROR: 'Du måste ange ditt lösenord',
    PASSWORD_NAME: 'password'
  },
  LOGIN_HEADER: 'Logga in',
  LOGIN_INGRESS: 'Logga in för att slutföra din beställning.',
  LOGIN_REGISTER: 'Ny kund?',
  LOGIN_CREATE_ACCOUNT: 'Skapa konto',
  PASSWORD_LINK: 'Glömt inloggningsuppgifter?'
};
svs.ticket_partner.digitalTickets.loginRegister.constants = {
  FORMS
};


 })(window);